"use client"
import ContentWithForm from "reusable/ContentWithForm"
import { getWarrantyExtensions, WarrantyBaseData } from "../../api/delek"
import { ButtonType, ContentItemType } from "../../typings/contentPage"

type Props = {
  data: WarrantyBaseData[]
}

const WarrantyExtensionPage = ({ data }: Props) => {
  const buttons: ButtonType[] = [
    { value: "licenseNumber", name: "מס׳ לוחית רישוי" },
    { value: "chassis", name: "מס׳ שלדה" },
  ]

  const headerText = [
    `האפשרות להארכת האחריות על ידי היצרן מוצגת לידיעה כללית בלבד. תחולתה של הארכת האחריות ביחס לרכב מסוים תיבחן ותיקבע באופן פרטני בהתאם להגדרות היצרן בהיבט זמן/מד אוץ וסייגים נוספים כפי שקבע היצרן במועד הבאתו של הרכב אל מרכז שירות מורשה.
    יצרן הרכב מודיע מעת לעת על הארכת אחריות לרכיבים מסוימים הרלוונטית לקבוצת רכבים מסויימת.`,
  ]

  return (
    <ContentWithForm
      title="בדיקת תכולת הארכת אחריות"
      headerText={headerText}
      background={[
        "/img/Warrantyextensionmobile.jpg",
        "/img/Warrantyextension.jpg",
      ]}
      subtitle="כדי לבדוק אם קיימת הארכת אחריות למאזדה שלך, יש להקליד כאן את מספר לוחית הרישוי או השלדה"
      buttons={buttons}
      inputLabel="מס׳ לוחית רישוי (משמאל לימין)"
      inputType="text"
      submitText="לבדיקה"
      bottomTitle="לתשומת ליבך"
      phoneNumber="08-9139995"
      bottomSubTitle="
      האפשרות להארכת האחריות על ידי היצרן מוצגת לידיעה כללית בלבד.
      תחולתה של הארכת האחריות ביחס לרכב מסוים תיבחן ותיקבע באופן פרטני בהתאם להגדרות היצרן בהיבט זמן/מד אוץ, אופי התקלה וסייגים נוספים כפי שקבע היצרן במועד הבאתו של הרכב אל מרכז שירות מורשה."
      getData={getWarrantyExtensions}
      type={ContentItemType.WARRANTYEXTENSION}
      tableData={data}
      page={"warranty"}
      breadCrumbName={"WarrantyExtension"}
    />
  )
}

export default WarrantyExtensionPage
